module.exports = __webpack_public_path__ + "static/media/Liqural-Logo.5927838c.png";